import { formatNumber } from '@trmediaab/zebra-utils';
import { Fragment } from 'react';

import { Disclaimer, FactElement, Headline } from './styles';

const TrackInfo = ({ track, avg }) => (
  <Fragment key={track.id}>
    <Headline>{track.name}</Headline>

    <FactElement
      items={[
        {
          label: 'Banlängd',
          value: `${formatNumber(track.length_total)} m`,
          mean: `${formatNumber(avg.length_total)} m`,
        },
        {
          label: 'Upploppslängd',
          value: `${formatNumber(track.length_home_stretch)} m`,
          mean: `${formatNumber(avg.length_home_stretch)} m`,
        },
        {
          label: 'Banbredd publiksträcka',
          value: `${formatNumber(track.width_1 / 100)} m`,
          mean: `${formatNumber(avg.width_1 / 100)} m`,
        },
        {
          label: 'Banbredd bortre långsida',
          value: `${formatNumber(track.width_2 / 100)} m`,
          mean: `${formatNumber(avg.width_2 / 100)} m`,
        },
        {
          label: 'Dosering',
          value: `${formatNumber(track.dosage / 100)} %`,
          mean: `${formatNumber(avg.dosage)} %`,
        },
        {
          label: 'Open stretch',
          value: track.open_stretch ? 'Ja' : 'Nej',
        },
        {
          label: 'Vinklad startbilsvinge',
          value: track.angled_wing ? 'Ja' : 'Nej',
        },
      ]}
    />
    <Disclaimer>
      Siffror inom parentes anger medianvärden för Sveriges samtliga travbanor.
    </Disclaimer>
  </Fragment>
);

export default TrackInfo;
